const initialState = {
  value: false,
  loaded: false,
};
export default initialState;
